<script>
    import { metaInfo } from "@/core/MetaInfo";
    import PaymentContent from "@/components/PaymentContent";
    import GuaranteeList from "@ivideon/components/GuaranteeList";

    export default {
        name: "Payment",
        components: {
            PaymentContent,
            GuaranteeList,
        },
        metaInfo() {
            return metaInfo.getMeta("delivery");
        },
    };
</script>

<template>
    <div class="l-container">
        <payment-content></payment-content>

        <div class="b-text-page__guarantee">
            <guarantee-list></guarantee-list>
        </div>
    </div>
</template>
